import { useEffect, useState } from 'react';
import api from '../services/api';

// Public challenge configuration also exists before the active reading window.
export default function useSeason() {
  const [season, setSeason] = useState(null);
  useEffect(() => {
    let cancelled = false;
    api.get('/challenges').then(({ data }) => {
      const next = data.challenges?.find(challenge =>
        challenge.isActive && challenge.startDate?.startsWith(`${new Date().getFullYear()}-`));
      if (!cancelled) setSeason(next || null);
    }).catch(() => { /* The invitation still works without the schedule. */ });
    return () => { cancelled = true; };
  }, []);
  return season;
}
